import { positionStreetAddressReq, positionStreetAddressRes } from "../models/geocode/positionTypes";
import { ApiResponse, apiCall } from "./apiClient";

export const getBatchOfGeocodes = (
    positions: positionStreetAddressReq[],
    useCaching = true,
    signal?: AbortSignal
): Promise<ApiResponse<positionStreetAddressRes[]>> => {
    return apiCall<positionStreetAddressRes[]>(
        `geocoding/batch?useCaching=${encodeURIComponent(useCaching)}`,
        "POST",
        positions,
        signal
    );
};